// App Info
export const APP_NAME = 'Ufuk Perde';
export const APP_VERSION = '1.12.0';

// Firebase Configuration
// YENİ FİREBASE PROJESİ İÇİN DEĞERLERİ BURAYA GİRİN
// Firebase Console > Project Settings > Your apps > Web app config değerlerini buraya kopyalayın
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAWJigfQlQSPKHAhjO7JmX8lGRjoOFG5q8",
  authDomain: "ufuk-perde.firebaseapp.com",
  projectId: "ufuk-perde",
  storageBucket: "ufuk-perde.firebasestorage.app",
  messagingSenderId: "861218307339",
  appId: "1:861218307339:web:17d804f6c71221c82ab60e",
  measurementId: "G-C9GQ8EJVCS"
};

// App Colors
export const COLORS = {
  primary: '#29472d',
  primaryHover: '#345a3a',
  secondary: '#f5f5f5',
  success: '#4caf50',
  error: '#f44336',
  warning: '#ff9800',
  info: '#2196f3',
  text: '#333',
  textLight: '#666',
  border: '#e1e5e9'
};

// Product Types
export const PRODUCT_TYPES = {
  tul: {
    label: 'Tül',
    fields: ['roomName', 'productName', 'width', 'height', 'pileModel', 'pileDensity', 'usedM2', 'unitPrice', 'extraPrice', 'capsuleUnitPrice', 'capsulePrice', 'altEtekKatlama', 'quantity', 'totalPrice', 'accessories'],
    calculations: (data) => {
      // Bu fonksiyon daha sonra detaylı hesaplamalar için kullanılacak
      return 0;
    }
  },
  kanat: {
    label: 'Kanat',
    fields: [
      'roomName', 'productName', 'width', 'height', 'pileModel', 'pileDensity', 'usedM2', 'unitPrice', 'extraPrice', 'capsuleUnitPrice', 'capsulePrice', 'quantity', 'totalPrice',
      'hasOzelTasarim', 'ozelProductName', 'ozelProductVariant', 'ozelWidth', 'ozelHeight', 'ozelUnitPrice', 'ozelPileModel', 'ozelPileDensity', 'ozelUsedM2', 'ozelExtraPrice', 'ozelQuantity', 'ozelCapsuleUnitPrice', 'ozelCapsulePrice', 'ozelTotalPrice',
      'hasAstar', 'astarProductName', 'astarProductVariant', 'astarUnitPrice', 'astarPrice',
      'accessories'
    ],
    calculations: (data) => {
      return 0;
    }
  },
  stor: {
    label: 'Stor',
    fields: ['roomName', 'productName', 'direction', 'width', 'height', 'usedM2', 'unitPrice', 'jumboSystem', 'reductor', 'bottomSkirt', 'closedCase', 'laser', 'totalPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  zebra: {
    label: 'Zebra',
    fields: ['roomName', 'productName', 'direction', 'width', 'height', 'usedM2', 'unitPrice', 'jumboSystem', 'reductor', 'bottomSkirt', 'closedCase', 'laser', 'totalPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  ahsapJaluzi: {
    label: 'Ahşap Jaluzi',
    fields: ['roomName', 'productName', 'direction', 'motorType', 'motorPrice', 'hasZigil', 'hasReduktor', 'hasKurdela', 'zigilAmount', 'width', 'height', 'usedM2', 'sistemTipi', 'unitPrice', 'mounting', 'totalPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  metalJaluzi: {
    label: 'Metal Jaluzi',
    fields: ['roomName', 'productName', 'direction', 'motorType', 'motorPrice', 'hasMetalZigil', 'hasMetalReduktor', 'hasIkiCamArasi', 'metalZigilAmount', 'ikiCamArasiAmount', 'width', 'height', 'usedM2', 'unitPrice', 'mounting', 'totalPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  dikeyPerde: {
    label: 'Dikey Perde',
    fields: ['roomName', 'productName', 'width', 'height', 'direction', 'usedM2', 'unitPrice', 'mounting', 'hasDikeyFon', 'motorType', 'motorPrice', 'totalPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  dikeyPvc: {
    label: 'Dikey PVC',
    fields: ['roomName', 'productName', 'width', 'height', 'direction', 'usedM2', 'unitPrice', 'mounting', 'motorType', 'motorPrice', 'totalPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  dikeyStor: {
    label: 'Dikey Stor',
    fields: ['roomName', 'productName', 'width', 'height', 'direction', 'usedM2', 'unitPrice', 'mounting', 'motorType', 'motorPrice', 'totalPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  plise: {
    label: 'Plise',
    fields: ['roomName', 'pliseProduct1Name', 'pliseProduct1Price', 'pliseProduct1Variation', 'pliseProduct2Name', 'pliseProduct2Price', 'pliseProduct2Variation', 'width', 'height', 'usedM2', 'mounting', 'quantity', 'totalPrice', 'notes'],
    calculations: (data) => {
      return 0;
    }
  },
  katlamaliPerde: {
    label: 'Katlamalı Perde',
    fields: ['roomName', 'productName', 'width', 'height', 'usedM2', 'fabricPrice', 'mechanismType', 'mechanismPrice', 'accessoryPrice', 'mounting', 'quantity', 'totalPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  raySistemi: {
    label: 'Ray Sistemleri',
    fields: ['roomName', 'productName', 'width', 'olcuTamamlama', 'usedMeter', 'unitPrice', 'mounting', 'quantity', 'totalPrice', 'notes'],
    calculations: (data) => {
      return 0;
    }
  },
  rustik: {
    label: 'Rustik',
    fields: ['roomName', 'productName', 'width', 'unitPrice', 'usedCm', 'ayakModel', 'ayakCap', 'ayakUzunluk', 'ayakRenkKodu', 'ayakSayisi', 'ekAyakSayisi', 'ayakUcreti', 'mounting', 'quantity', 'totalPrice', 'notes', 'rustikAksesuarlar', 'rustikRaySecenekleri'],
    calculations: (data) => {
      return 0;
    }
  },
  aksesuar: {
    label: 'Aksesuar',
    fields: ['roomName', 'productName', 'quantity', 'unitPrice'],
    calculations: (data) => {
      return 0;
    }
  }
};

// Ahşap ve Metal Jaluzi Sistem Tipleri
export const JALUZI_SISTEM_TIPLERI = {
  merdivenIpli: 'Merdiven İpli',
  kurdeleli: 'Kurdeleli',
  merdivenIpliReduktorlu: 'Merdiven İpli Redüktörlü',
  kurdelaliReduktorlu: 'Kurdelalı Redüktörlü'
};

// Yön Tipleri
export const DIRECTION_TYPES = {
  LEFT: 'Sol',
  RIGHT: 'Sağ'
};

// Dikey Ürün Yön Tipleri
export const DIKEY_DIRECTION_TYPES = {
  SAGA: 'Sağa açılım',
  SOLA: 'Sola açılım',
  ORTADAN: 'Ortadan açılım'
};

// Motor Tipleri
export const MOTOR_TYPES = {
  MOTOR_1: 'Motor',
  MOTOR_2_KUMANDA: 'Motor + Kumanda'
};


// Tül ve Kanat Pile Modelleri
export const TUL_PILE_MODELS = {
  standartSeyrek: 'Standart SEYREK',
  standartOrta: 'Standart ORTA',
  standartSik: 'Standart SIK',
  sPile: 'S Pile',
  amerikanPile2li: 'Amerikan Pile 2\'li',
  amerikanPile3lu: 'Amerikan Pile 3\'lü',
  kapsulPile: 'Kapsül Pile',
  cimaDikis: 'Çima Dikiş',
  duzDikis: 'Düz Dikiş',
  kumasGuneslik: 'Kumaş Güneşlik'
};

// Kanat Pile Modelleri (Tül ile aynı)
export const KANAT_PILE_MODELS = {
  standartSeyrek: 'Standart SEYREK',
  standartOrta: 'Standart ORTA',
  standartSik: 'Standart SIK',
  sPile: 'S Pile',
  amerikanPile2li: 'Amerikan Pile 2\'li',
  amerikanPile3lu: 'Amerikan Pile 3\'lü',
  kapsulPile: 'Kapsül Pile',
  cimaDikis: 'Çima Dikiş',
  duzDikis: 'Düz Dikiş',
  kumasGuneslik: 'Kumaş Güneşlik'
};

// Pile Sıklığı Değerleri
export const PILE_DENSITY_VALUES = {
  standartSeyrek: 2,
  standartOrta: 2.5,
  standartSik: 3,
  sPile: 3,
  amerikanPile2li: 3,
  amerikanPile3lu: 3,
  kapsulPile: 3
};

// Routes
export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  LOGIN: '/'
};

// Notification Types
export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

// Local Storage Keys
export const STORAGE_KEYS = {
  USER_SESSION: 'user_session',
  THEME: 'theme'
};

// Order Status Types
export const ORDER_STATUS = {
  NEW_ORDER: 'new_order',
  FIRMA: 'firma',
  ATOLYE: 'atolye',
  MONTAJ: 'montaj',
  DELIVERED: 'delivered'
};

export const ORDER_STATUS_LABELS = {
  [ORDER_STATUS.NEW_ORDER]: 'Yeni Sipariş',
  [ORDER_STATUS.FIRMA]: 'Firma',
  [ORDER_STATUS.ATOLYE]: 'Atölye',
  [ORDER_STATUS.MONTAJ]: 'Montaj',
  [ORDER_STATUS.DELIVERED]: 'Teslim Edildi'
};

// Pagination Options
export const PAGINATION_OPTIONS = [5, 10, 15, 20, 25, 50, 100];

// Ödeme Tipleri
export const PAYMENT_TYPES = {
  CASH: 'cash',
  IBAN: 'iban',
  CREDIT_CARD: 'credit_card'
};

export const PAYMENT_TYPE_LABELS = {
  [PAYMENT_TYPES.CASH]: 'Elden Nakit',
  [PAYMENT_TYPES.IBAN]: 'IBAN',
  [PAYMENT_TYPES.CREDIT_CARD]: 'Kredi Kartı'
};
